import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import {
  CssBaseline,
  ScopedCssBaseline,
  ThemeProvider,
  useColorScheme,
  useMediaQuery
} from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
import { useCreateTidalTheme } from "./useCreateTidalTheme.js";
const emptyStyle = {};
function TidalThemeProvider(props) {
  const {
    theme: customThemeOptions,
    style = emptyStyle,
    children,
    className = "",
    cssBaselineMode = "global",
    enableColorScheme = false,
    forceThemeRerender
  } = props;
  const { mode: muiMode = "light" } = useColorScheme();
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const mode = muiMode === "system" ? prefersDarkMode ? "dark" : "light" : muiMode;
  const theme = useCreateTidalTheme(mode, customThemeOptions);
  return /* @__PURE__ */ jsxs(ThemeProvider, { defaultMode: "light", forceThemeRerender, theme, children: [
    cssBaselineMode === "disabled" && children,
    cssBaselineMode === "global" && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(CssBaseline, { enableColorScheme }),
      children
    ] }),
    cssBaselineMode === "scoped" && /* @__PURE__ */ jsx(
      ScopedCssBaseline,
      {
        className,
        "data-testid": "tidalScopedCssBaseline",
        enableColorScheme,
        style,
        children
      }
    )
  ] });
}
validateTidalLicense();
export {
  TidalThemeProvider
};
//# sourceMappingURL=TidalThemeProvider.js.map
